<!--快捷打分面板-->
<template>
	<div class="fast-score-wrap">
		<div class="fast-score" ref="board">
			<div class="title">快捷打分<span class="info-title">（右键点击提交）</span></div>
			<div class="fast-content">
				<div class="fast-chose-radio">
					<span class="tit">打分模式：</span>
					<el-radio-group v-model="radioChose" @change="changeFastScore">
						<el-radio label="+">加分</el-radio>
						<el-radio label="-">减分</el-radio>
					</el-radio-group>
				</div>
				<div class="fast-chose">
					<span class="tit">设置步长：</span>
					<div class="sel-step" v-if="Number(this.originalStep) === 0">
						<el-select v-model="stepScore" placeholder="请选择" @change="getFastScoreInfo">
							<el-option v-for="item in options" v-show="item.show" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</div>
					<div class="sel-step" v-else>{{ stepScore }}</div>
				</div>
			</div>
			<div class="ope-fast-score">
				<div class="submit-fast-score submit-fast-score-del" @click="delFastScore">
					删除
				</div>
				<div class="submit-fast-score" @click="submitFastScore" :class="{ 'submit-btn-state': loadingState }">
					{{ isHistoryState ? '保存修改' : '提交' }}
				</div>
			</div>
		</div>
		<guide
			class="guide-fast-score-board"
			v-if="guideStep === 7"
			title="快捷打分"
			distribute="快捷打分，有加分和减分两种方式，选取步长之后，点击试卷进行快捷打分，点击删除按钮，可对快捷打分删除"
			:isTopArr="false"
		/>
	</div>
</template>
<script>
import { mapActions } from 'vuex'
import drag from '../../../mixin/drag-mixin'
import guideMixin from '../utils/guide-mixin'
import { isAllGetScore } from '@/views/exam/utils/help'
export default {
	name: 'fast-score-board',
	mixins: [drag, guideMixin],
	components: { guide: () => import('./guide') },
	data() {
		return {
			//减分还是减分
			radioChose: '+',
			//步长
			options: [
				{ value: '0.5', label: '0.5分' },
				{ value: '1', label: '1分' },
				{ value: '1.5', label: '1.5分' },
				{ value: '2', label: '2分' },
				{ value: '3', label: '3分' },
				{ value: '4', label: '4分' },
				{ value: '5', label: '5分' },
				{ value: '10', label: '10分' }
			],
			//步长值
			stepScore: 1,
			//打分 列表
			scoreList: [],
			//多个打分的情况下  当前激活的索引
			currentIndex: 0,
			//基本信息
			basicInfo: {},
			// 是否快捷打三分
			isFastClick: false,
			query: this.$route.query,
			//历史面板打分  状态u
			historyBoardState: false,
			//初始的步长
			originalStep: null,
			//位置
			dragStartX: -45,
			dragStartY: 0,
			//图片列表
			imgAddrListInfo: {},
			//开始打分时间
			startTime: 0,
			//图片是否水平拼接
			isHorizontalImage: false,
			//loading
			loadingState: false,
			// 是不是历史状态
			isHistoryState: false,
			//no use
			rotateDegree: 0,
			//放大倍数
			scaleState: 1,
			//阅卷类型
			examType: null,
			examRemark: ''
		}
	},
	created() {
		this.examType = this.query.type
	},
	mounted() {
		this.getScreenWidth()
		this.watchEmitValues()
		this.$nextTick(() => {
			this.dragStartY = 285
			this.$refs['board'].style.transform = `translateX(${this.dragStartX}px) translateY(${this.dragStartY}px)`
		})
	},
	methods: {
		...mapActions('examination/databases', ['set', 'get']),
		// 屏幕宽度
		getScreenWidth() {
			if (window.screen.width <= 1920) {
				this.dragStartX = -350
			}
		},
		//eventBus
		watchEmitValues() {
			this.eventBus.$on('isTypical', cb => {
				if (cb.state) {
					this.examType = 1
					this.examRemark = cb.text
				} else {
					this.examType = this.query.type
				}
			})
			this.eventBus.$on('emitScoreCurrentIndex', cb => (this.currentIndex = cb))
			this.eventBus.$on('isHistoryState', cb => (this.isHistoryState = cb))
			this.eventBus.$on('historyBoardState', cb => (this.historyBoardState = cb))
			this.eventBus.$on('horizontalChange', cb => (this.isHorizontalImage = cb))
			this.eventBus.$on('startTime', cb => (this.startTime = cb))
			this.eventBus.$on('imgAddrListInfo', cb => (this.imgAddrListInfo = cb.imgAddrList))
			this.eventBus.$on('emitCurrentStepScore', async cb => {
				this.originalStep = cb.stepScore
				const pathKey = this.query.markingTaskId + this.scoreList[this.currentIndex].pkId
				const localSel = await this.get({ dbName: 'database', path: 'fastScoreStep.' + pathKey, user: true })
				this.stepScore = 1
				if (Number(cb.stepScore) > 0) {
					this.stepScore = Number(cb.stepScore)
				} else if (localSel && Number(cb.stepScore) === 0) {
					this.stepScore = localSel
				}
			})
			this.eventBus.$on('emitScoreList', cb => {
				this.scoreList = cb
				this.options.forEach(res => {
					if (cb[this.currentIndex].score % Number(res.value) === 0) {
						res.show = true
					} else {
						res.show = false
					}
				})
			})
			this.eventBus.$on('isFastScoreState', async cb => {
				if (cb) {
					this.isFastClick = cb
					if (!this.historyBoardState) {
						this.eventBus.$emit('changeFastScoreInfo', { key: this.radioChose, val: this.stepScore })
						const pathKey = this.query.markingTaskId + this.scoreList[this.currentIndex].pkId
						const localSel = await this.get({ dbName: 'database', path: 'fastScoreStep.' + pathKey, user: true })
						this.stepScore = localSel ? localSel : this.scoreList[0].stepScore > 0 ? this.scoreList[0].stepScore : 1
					}
				}
			})
			this.eventBus.$on('basicInformation', cb => {
				if (cb?.imgAddr && this.isHistoryState) {
					if (Object.keys(JSON.parse(cb.imgAddr).imgAddr).length > 0) {
						this.radioChose = JSON.parse(cb.imgAddr).imgAddr['active0'][0][2]?.slice(0, 1)[0]
					}
				}
				this.basicInfo = cb
			})
			this.eventBus.$on('changeFastScoreInfo', cb => {
				this.radioChose = cb.key
				this.stepScore = cb.val
			})
		},
		// 获取快捷打分信息
		getFastScoreInfo(step) {
			this.stepScore = step
			// if (!this.stepScore) {
			// 	this.$message({ type: 'error', message: '请选择步长值', duration: 3000 })
			// 	return false
			// }
			this.eventBus.$emit('changeFastScoreInfo', { key: this.radioChose, val: this.stepScore, isToZero: 'isToZero' })
			const pathKey = this.query.markingTaskId + this.scoreList[this.currentIndex].pkId
			this.set({ dbName: 'database', path: 'fastScoreStep.' + pathKey, value: this.stepScore, user: true })
			this.eventBus.$emit('emitCurrentStepScore', this.scoreList[this.currentIndex])
			this.eventBus.$emit('imgAddrListInfo', { imgAddrList: this.imgAddrListInfo })
		},
		// 切换 加分或减分
		changeFastScore() {
			this.currentIndex = 0
			this.eventBus.$emit('emitScoreCurrentIndex', 0)
			this.eventBus.$emit('changeFastScoreInfo', { key: this.radioChose, val: this.stepScore })
			this.eventBus.$emit('imgAddrListInfo', { imgAddrList: {} })
		},
		// 提交快捷打分
		submitFastScore() {
			if (!this.judgeScore()) {
				this.$message({ type: 'error', message: '打分不合法!!', duration: 3000 })
				return false
			}
			if (this.progressInfoNum === 100 && this.isHistoryState === false) return false
			const _this = this
			let totalScore = 0
			this.loadingState = true
			this.scoreList.forEach(res => {
				totalScore += Number(res.getScore)
			})
			isAllGetScore(this.scoreList).then(res => {
				if (res) {
					const duration = new Date().getTime() - this.startTime
					if (Number(this.basicInfo.studentId) < 0) {
						this.$message({ type: 'error', message: '暂无试卷', duration: 3000 })
						this.loadingState = false
						return false
					}
					import('../utils/help').then(resp => {
						resp.submitScore(
							this,
							this.query,
							this.scoreList,
							this.basicInfo,
							this.imgAddrListInfo,
							duration,
							this.examType,
							this.isFastClick,
							this.isHorizontalImage,
							this.examRemark
						).then(response => {
							setTimeout(() => {
								_this.loadingState = false
							}, 50)
							if (response.code === '200') {
								_this.eventBus.$emit('flushData')
								this.eventBus.$emit('isHistoryState', false)
								this.eventBus.$emit('isTypical', { state: false })
								this.$bigScore({ score: totalScore, dom: this.$parent.$refs['home'] })
							}
						})
					})
				} else {
					this.$message({ message: '请对所有题目打分', type: 'error', duration: 3000 })
					_this.loadingState = false
				}
			})
		},
		//删除快捷打分
		delFastScore() {
			this.eventBus.$emit('examDelFastScore')
		},
		// 判断打的分是否超过了最高分
		judgeScore() {
			let isLegal = true
			this.scoreList.forEach(res => {
				if (Number(res.getScore) > res.score) {
					this.$message({ type: 'error', message: '打分不能超过题块总分：' + res.score, duration: 3000, dangerouslyUseHTMLString: true })
					isLegal = false
				}
			})
			return isLegal
		}
	}
}
</script>

<style scoped lang="less">
.fast-score-wrap {
	.fast-score {
		width: 280px;
		padding: 0 15px 15px;
		box-sizing: border-box;
		background: white;
		position: absolute;
		right: 0;
		top: 0;
		border-radius: 8px;
		z-index: 19;
		cursor: move;
		box-shadow: 0 0 10px rgb(185, 180, 180);
		transform: translateX(-430px);
		@media screen and (max-width: 1920px) {
			transform: translateX(-350px);
		}
		.title {
			height: 35px;
			display: flex;
			//justify-content: space-between;
			align-items: center;
			font-size: 16px;
			border-bottom: 1px solid #e6e6e6;
			.info-title {
				color: red;
			}
			.iconfont {
				cursor: pointer;
				font-size: 15px;
			}
		}
		.fast-chose-radio {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			/deep/.el-radio-group {
				width: 160px;
				margin-left: 10px;
				height: 56px;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				.el-radio {
					padding: 0;
					margin-bottom: 0;
					margin-right: 15px;
				}
			}
		}
		.fast-content {
			.tit {
				width: 160px;
				font-size: 16px;
			}
		}
		.fast-chose {
			height: 30px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
		}
		.ope-fast-score {
			display: flex;
			justify-content: space-between;
		}
		.submit-fast-score {
			width: 46%;
			height: 35px;
			background: #ff7200;
			border: 1px solid #ff7200;
			border-radius: 2px;
			text-align: center;
			line-height: 35px;
			color: #ffffff;
			font-size: 16px;
			margin: 10px auto 0;
			&:hover {
				cursor: pointer;
			}
		}
		.submit-fast-score-del {
			background: #009688;
			border: 1px solid #009688;
		}
		.submit-btn-state {
			background: black;
		}
	}
}
</style>
